// extracted by mini-css-extract-plugin
export var actions = "_ro-4";
export var item = "_ro-1";
export var price = "_ro-3";
export var quantity = "_ro-2";
export var table = "_ro-0";